import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { DispatchProp } from 'modules/store'

import { AccessRolesSchema } from '../../../schemas'

import { State as AppState } from '../../store'

import { links } from '../../app.links'
import { getPrivileges } from '../store'

type Roles = keyof AccessRolesSchema
export type Props = OwnProps & DispatchProp & StateToProps

type OwnProps = {
  rights: Roles[]
  redirect?: boolean
}

type StateToProps = {
  privileges: AccessRolesSchema
}

const mapStateToProps = (state: AppState) => ({
  privileges: getPrivileges(state),
})

const enhance = connect(mapStateToProps)
export class Privilege extends Component<Props> {
  render() {
    const { children, privileges, rights, redirect } = this.props

    const hasAccess = rights.every((right) => privileges[right])
    const redirectTo = <Redirect to={links.auth.notAuthorized()} />

    return hasAccess ? children : redirect ? redirectTo : null
  }
}

export default enhance(Privilege)



// WEBPACK FOOTER //
// ./src/app/auth/components/privilege.tsx